<template>
  <div>
    <ChengKuangSaleInvoice v-if="userInfo.businessGroup == '城矿'" />
    <WuMaoSaleInvoice v-else />
  </div>
</template>

<script>
  import ChengKuangSaleInvoice from './chengkuang/list.vue';
  import WuMaoSaleInvoice from './list.vue';
  export default {
    name: 'saleInvoiceList',
    components: { ChengKuangSaleInvoice, WuMaoSaleInvoice },
  };
</script>

<style lang="scss" scoped></style>
